import { render, staticRenderFns } from "./syncList.vue?vue&type=template&id=4f50133b&scoped=true"
import script from "./syncList.vue?vue&type=script&lang=js"
export * from "./syncList.vue?vue&type=script&lang=js"
import style0 from "./syncList.vue?vue&type=style&index=0&id=4f50133b&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f50133b",
  null
  
)

export default component.exports